import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { jobsAPI as API } from "../../apis/jobs";
import { RootState } from "../store";

export const loadJobs = createAsyncThunk(
  "jobs/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { jobs } = getState() as RootState;
      if (jobs.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Job>();
interface State extends EntityState<Job> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: State = {
  ...itemsAdapter.getInitialState(),
  status: "idle",
};

const slice = createSlice({
  name: "jobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadJobs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadJobs.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadJobs.fulfilled, (state, action) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, action.payload.data);
      });
  },
});

export default slice.reducer;
